import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { useState,useEffect } from 'react';
import { useAuthLocalStorage } from './moduls/useLocalStore';
import './App.css';
import Chat from './chat/chat';
import VKCallback from './callback/callback.jsx';
import YaCallback from "./callback/callbackyandex.jsx";
import GoCallback from "./callback/callbackgoogle.jsx";
import IndexPage from "./pages/index.jsx";
import Gpt from "./pages/gpt.jsx";
import Four from "./pages/four.jsx";
import PromoInfo from "./pages/promoinfo.jsx";
import Charge from "./pages/charge.jsx";
import Back from "./pages/back.jsx";
import Status from "./pages/status.jsx";


function App() {
  const { token, saveToken, removeToken } = useAuthLocalStorage();
  const [user,setUser] = useState({
        popup: 0
    });
    const [chats, setChats] = useState([
    ]);
    const [activeChatId, setActiveChatId] = useState(null);
  function changePopup(id) {
        setUser(prev => ({
            ...prev,
            popup: id,
        }));
    }
    function UtmTracker() {
      const location = useLocation();

      useEffect(() => {
        const params = new URLSearchParams(location.search);
        const utm = params.get("utm_source");

        if (utm) {
          localStorage.setItem("utm_source", utm);
        }
        const h1 = params.get("h1");

        if (h1) {
          localStorage.setItem("h1", h1);
        }
      }, [location.search]);

      return null;
  }
   useEffect(() => {
      if(token){
          changePopup(0);
          const fetchProfile = async () => {
          try {
            const res = await fetch("https://im-gpt.ru:3000/api/getProfile", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
              }
            });

            const data = await res.json();

            if (res.ok && data.load) {
              const profile = data.load;
      
          // Обновляем пользователя
              setUser(prev => ({
                ...prev,
                id: profile.id,
                name: profile.name,
                pic: profile.pic,
                email: profile.email,
                password: profile.password,
                token: profile.token,
                sub: profile.sub,
                timesub: profile.timesub,
                nextpay: profile.nextpay,
                utm: profile.utm
              }));

              // Обновляем чаты, преобразуем под текущую структуру
              const apiChats = profile.chats || [];
              const newChats = apiChats.map(c => ({
                id: c.id,
                name: c.name,
                modelId: c.model
              }));

              setChats(newChats);
              if(newChats.length > 0) setActiveChatId(newChats[0].id);
              setLogin(true);
            } else {
              removeToken();
            }
          } catch (err) {
            console.error(err);
            removeToken();
          } finally {
            
          }
        };
          fetchProfile();
         
          
        
      }
      else
      {
         setLogin(false);
      }
  }, [token]);
  const [login,setLogin] = useState(false);
  return (
    <Router>
       <UtmTracker />
      <Routes>
        <Route path="/" element={ <IndexPage login={login} setLogin={setLogin} user={user} setUser={setUser}/>} />
        <Route path="/chat" element={ <Chat login={login} setLogin={setLogin} user={user} setUser={setUser} token={token} removeToken={removeToken} saveToken={saveToken} chats={chats} setChats={setChats} activeChatId={activeChatId} setActiveChatId={setActiveChatId}/>} />
        <Route path="/ipromo" element={ <PromoInfo login={login} setLogin={setLogin} user={user} setUser={setUser}/>} />
        <Route path="/charge" element={ <Charge login={login} setLogin={setLogin} user={user} setUser={setUser}/>} />
        <Route path="/back" element={ <Back login={login} setLogin={setLogin} user={user} setUser={setUser}/>} />
        <Route path="/status" element={ <Status login={login} setLogin={setLogin} user={user} setUser={setUser}/>} />
        <Route path="/api/vk" element={<VKCallback token={token} removeToken={removeToken} saveToken={saveToken}/>} />
        <Route path="/api/yandex" element={<YaCallback token={token} removeToken={removeToken} saveToken={saveToken}/>} />
        <Route path="/api/google" element={<GoCallback token={token} removeToken={removeToken} saveToken={saveToken}/>} />
        <Route path="/gpt" element={ <Gpt login={login} setLogin={setLogin} user={user} setUser={setUser}/>} />
        <Route path="*" element={<Four login={login} setLogin={setLogin} user={user} setUser={setUser}/>} />
      </Routes>
    </Router>

  );
}

export default App;
